import AppRouter from './AppRouter';
import '@/App.css';

export default AppRouter;
